export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9327.24622c02.jpg";